import React, { useMemo } from 'react';
import { Button } from '@tishman/components';
import { navigate } from 'gatsby';

import { selectCheckoutCart, useAppSelector } from '../store';
import { useLocalizedLink } from '../utils/use-localized-link';
import { newRelic } from '../utils/new-relic';

export const AddToCartNav: React.FC = () => {
  const shopCart = useAppSelector(selectCheckoutCart);
  const getLocalizedLink = useLocalizedLink();

  const cartTotalQty = useMemo(() => {
    if (!shopCart?.selections) return 0;

    const keys = Object.keys(shopCart.selections);
    return keys.reduce(
      (acc, curr) => acc + (shopCart.selections[curr] ?? []).length,
      0,
    );
  }, [shopCart?.selections]);

  return (
    <Button
      data-gtm-initiator="nav"
      id="view-cart"
      onClick={() => {
        newRelic.logCartAction('AddToCartNav - View Cart', 'onClick');
        navigate(getLocalizedLink('/cart/'));
      }}
      sx={{
        'py': '0px',
        'w': '26px',
        'h': '26px',
        'pt': '10px',
        'pl': ['6px', '15px'],
        'mt': cartTotalQty > 0 ? '-3px' : '0px',
        'pr': cartTotalQty > 0 ? '15px' : '18px',
        '> *': {
          // Move svg underneath button, so that GTM click event always fires
          position: 'relative',
          zIndex: -1,
        },
      }}
      variant="iconUnderline"
    >
      {cartTotalQty > 0 ? (
        <svg
          fill="none"
          height="24"
          viewBox="0 0 24 24"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="Cart">
            <g id="Group 11">
              <path
                d="M6 18C6.53043 18 7.03914 18.2107 7.41421 18.5858C7.78929 18.9609 8 19.4696 8 20C8 20.5304 7.78929 21.0391 7.41421 21.4142C7.03914 21.7893 6.53043 22 6 22C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20C4 19.4696 4.21071 18.9609 4.58579 18.5858C4.96086 18.2107 5.46957 18 6 18ZM6 18H17M6 18V4H4M17 18C17.5304 18 18.0391 18.2107 18.4142 18.5858C18.7893 18.9609 19 19.4696 19 20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22C16.4696 22 15.9609 21.7893 15.5858 21.4142C15.2107 21.0391 15 20.5304 15 20C15 19.4696 15.2107 18.9609 15.5858 18.5858C15.9609 18.2107 16.4696 18 17 18ZM6 6L12 6.429M19.138 13.002L18.995 14.002H5.995"
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
            </g>
            <circle cx="18" cy="6" fill="currentColor" id="Ellipse 27" r="3" />
          </g>
        </svg>
      ) : (
        <svg
          fill="none"
          height={24}
          viewBox="0 0 24 24"
          width={24}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.705 15.039a2 2 0 1 1-.084 3.998 2 2 0 0 1 .084-3.998Zm0 0 10.998.231M3.705 15.04 4 1.042 2 1m12.703 14.27a2 2 0 1 1-.084 3.999 2 2 0 0 1 .084-3.999ZM3.958 3.042l13.975 1.294-1.147 6.977L3.79 11.04"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
          />
        </svg>
      )}
    </Button>
  );
};
